import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'

export const GridContainer = styled.div`
  display: grid;
  width: 100vw;
  height: 100dvh;
  background: var(--color-white);
  overflow: hidden;
  grid-template-columns: 64px 1fr 64px;
  grid-template-rows: 64px 1fr 96px;
  grid-template-areas:
    'top-left top-center top-right'
    'middle-left middle-center middle-right'
    'bottom-full bottom-full bottom-full';

  @media screen and ${breakpoint.m} {
    grid-template-columns: 64px 1fr 64px;
    grid-template-rows: 64px 1fr 96px;
    grid-template-areas:
      'top-left top-center top-right'
      'middle-center middle-center middle-center'
      'bottom-full bottom-full bottom-full';
  }
`

export const GridArea = styled.div<{ $area: string }>`
  grid-area: ${props => props.$area};

  ${props =>
    (props.$area === 'middle-left' || props.$area === 'middle-right') &&
    `
    display: flex;
    justify-content: center;
    padding-bottom: 16px;


    @media screen and ${breakpoint.m} {
      display: none;
    }
  `}
  ${props =>
    (props.$area === 'top-left' || props.$area === 'top-right') &&
    `
      display: flex;
      align-items: center;
      justify-content: center;
  `}

  ${props =>
    props.$area === 'middle-center' &&
    `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      overflow: hidden;
      padding-bottom: 16px;
      box-sizing: border-box;
      --image-size: calc(100dvh - 160px - 16px);

      @media screen and ${breakpoint.m} {
        padding: 0 16px 16px 16px;
        --image-size: calc(100dvh - 160px - 32px);
      }
   `}

  ${props =>
    props.$area === 'bottom-full' &&
    `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-top: 1px solid var(--color-sw-10);
      padding: 16px;
      box-sizing: border-box;
  `}
`

export const CarouselContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CarouselWrapper = styled.div`
  .carousel {
    width: 100%;
    position: relative;
  }
`
